var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import CheckIcon from '@mui/icons-material/Check';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { submitPaymentResponse } from '../../../../api/Payments/paymentService';
import { descargarPDFBase64, encodeUnicodeToBase64, htmlBase64ToPdf } from '../../../../api/printService';
import { getProfileWithoutAuthToken } from '../../../../application/usecases/getCompanyInfoV2';
import { LOGO_HORZ_ENDOSO } from '../../../../assets/images';
import { formatDecimals } from '../../../../utils/textUtils';
import Footer from '../../../common/Footer/Footer';
import Loader from '../../../common/Loaders/Loader';
const PaymentsFeedbackOk = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(true);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [responseContent, setResponseContent] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const contentRef = useRef(null);
    const printBill = () => {
        window.print();
    };
    const downloadBill = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!contentRef.current)
            return;
        try {
            setIsDownloading(true);
            const html = `
                <!DOCTYPE html>
                <html lang="es">
                <head>
                    <meta charset="UTF-8">
                    <title>Pago realizado</title>
                    <style>
                    body{
                        width: 180mm;
                        max-width: 180mm;
                    }

                    .logo-print{
                        display:none;
                    }

                    .header-logo {
                        max-width: 260px !important;
                        max-height: auto;
                        margin: 0px 0 0 10px;
                        order: 0;
                        cursor: pointer;
                    }

                    .row {
                        width:100%;                        
                        padding: 0 16px;
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: calc(-1* var(--bs-gutter-y));
                    }

                    .col-12 {
                        flex: 0 0 auto;
                        width: 100%;
                    }

                    .col-print-6, .col-6 {
                        width: 45% !important; /* Simula col-6 en impresión */
                        margin-bottom: 20px;
                    }

                    .payments-feedback-header {
                        padding-top: 0px;
                        position: sticky;
                        top: 0px;
                        background-color: #FFFF; /* --color-grey-lighter */
                        z-index: 9;
                    }

                    .payments-feedback-header .header-content {
                        position: relative;
                        padding: 40px 20px 20px 20px;
                        background-color: #fff; /* --color-white */
                        border-top-left-radius: 40px;
                        border-top-right-radius: 40px;
                    }

                    .payments-feedback-body {
                        padding: 20px 20px 20px 20px;
                        background-color: #fff; /* --color-white */
                        border-bottom-left-radius: 40px;
                        border-bottom-right-radius: 40px;
                        min-height: calc(100vh - 230px);
                    }

                    .payments-feedback-body h2.title {
                        font-size: 1.5rem;
                        font-weight: 700;
                        font-family: 'Mada', sans-serif; /* --main-font */
                        color: #1f2037; /* --font-color-primary */
                        margin-bottom: 20px;
                        padding-left: 16px;
                    }

                    .payments-feedback-body h2.title .check {
                        display:none
                    }

                    .payments-feedback-body .header-section {
                        line-height: 42px;
                        padding: 0 15px;
                        margin-bottom: 20px;
                        background-color: #f0f0f4; /* --color-lila-100 */
                        border-radius: 10px;
                        font-size: 1.25rem;
                        font-weight: 700;
                        font-family: 'Mada', sans-serif; /* --main-font */
                        color: #1f2037; /* --font-color-primary */
                    }

                    .payments-feedback-body .value {
                        font-size: 1rem;
                        font-weight: 700;
                        font-family: 'Poppins', sans-serif; 
                        color: #1f2037; 
                        margin: 0;
                    }

                    .payments-feedback-body .lbl {
                        font-size: 1rem;
                        font-weight: 300;
                        font-family: 'Poppins', sans-serif; 
                        color: #1f2037;
                        margin: 0;
                    }

                    .payments-feedback-body .breakdown-content {
                        width:100%
                        padding: 20px 0;
                        margin: 0;
                        border-top: 1px solid #babee3; 
                        border-bottom: 1px solid #babee3;
                        .col-6{
                            width:50%;
                            margin: 20px 0;
                        }
                    }

                    .payments-feedback-body .subtotal-tax-content {
                        width:100%
                        padding: 20px 0;
                        margin: 20px 0;
                        border-bottom: 1px solid #babee3;
                        .col-6{
                            width:50%;
                            margin: 20px 0;
                        }
                    }

                    .payments-feedback-body .total-content {
                        width:100%
                        margin: 20px 0;
                        .col-6{
                            width:50%;
                            margin: 20px 0;
                        }
                    }

                    .payments-feedback-body .total-text {
                        font-size: 1.25rem;
                        font-weight: 700;
                        font-family: 'Poppins', sans-serif;
                        color: #1f2037; 
                        margin: 0;
                    }

                    .payments-feedback-body .cta-pay-content {
                        display: none;
                    }

                    .info-icon{
                        display:none
                    }

                    .text-end {
                        text-align: right !important;
                    }

                    .main-footer-page{
                        display: none;
                    }

                    .data-resumen-invoice-print{
                        margin-top:40px;
                    }

                    </style>
                </head>
                <body>   
                    ${contentRef.current.outerHTML}
                </body>
                </html>  
              `;
            const htmlBase64 = encodeUnicodeToBase64(html);
            const pdfBase64 = yield htmlBase64ToPdf(htmlBase64);
            if (!pdfBase64 || typeof pdfBase64 !== 'string' || !pdfBase64.startsWith('JVBER')) {
                console.error('No se pudo generar un PDF válido');
                return;
            }
            descargarPDFBase64(pdfBase64, `${responseContent === null || responseContent === void 0 ? void 0 : responseContent.numOrder}.pdf`);
        }
        catch (error) {
            console.error('Error al generar o descargar el PDF:', error);
        }
        finally {
            setIsDownloading(false); // ✅ Reactivar el botón
        }
    });
    useEffect(() => {
        setIsLoading(true);
        const fetchPaymentResponse = () => __awaiter(void 0, void 0, void 0, function* () {
            const queryParams = new URLSearchParams(location.search);
            const ds_SignatureVersion = queryParams.get('Ds_SignatureVersion');
            const ds_MerchantParameters = queryParams.get('Ds_MerchantParameters');
            const ds_Signature = queryParams.get('Ds_Signature');
            try {
                const response = yield submitPaymentResponse({
                    ds_MerchantParameters,
                    ds_Signature,
                    ds_SignatureVersion,
                });
                if (response !== null) {
                    setResponseContent(response);
                }
            }
            catch (error) {
                console.error('Error al procesar respuesta del pago:', error);
                setIsError(true);
            }
            finally {
                setIsLoading(false);
            }
        });
        fetchPaymentResponse();
    }, []);
    useEffect(() => {
        if (responseContent) {
            const fetchUserProfile = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setIsLoading(true);
                    const response = yield getProfileWithoutAuthToken(responseContent.companyId);
                    setUserProfile(response);
                }
                catch (error) {
                    console.error('Error al obtener el user profile:', error);
                    setIsError(true);
                }
                finally {
                    setIsLoading(false);
                }
            });
            fetchUserProfile();
        }
    }, [responseContent]);
    const formatDateToSpanishLong = (input) => {
        if (!input) {
            return;
        }
        const [datePart, timePart] = input.split(' ');
        const [day, month, year] = datePart.split('/').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);
        var formatedDate = new Date(year, month - 1, day, hour, minute);
        return new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(formatedDate);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsxs("title", { children: ["SIGNO | ", t('payments.title')] }) }), isLoading ? (_jsx(Loader, { cssClass: 'grid-mt-8' })) : (_jsxs("div", Object.assign({ ref: contentRef, className: "payments-feedback" }, { children: [_jsx("div", Object.assign({ className: "container-xl payments-feedback-header" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-md-11 header-content mx-auto" }, { children: _jsx("img", { alt: "SIGNO", onClick: () => navigate('/'), className: "header-logo", src: LOGO_HORZ_ENDOSO }) })) })) })), _jsx("div", Object.assign({ className: "container-xl" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsxs("div", Object.assign({ className: "col-12 col-md-11 payments-feedback-body mx-auto" }, { children: [_jsx("div", Object.assign({ className: "logo-print" }, { children: _jsx("img", { alt: "SIGNO", onClick: () => navigate('/'), className: "header-logo", src: LOGO_HORZ_ENDOSO }) })), _jsxs("h2", Object.assign({ className: "title" }, { children: [t('payments.feedback.title'), _jsx(CheckIcon, { className: "check" })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsxs("div", Object.assign({ className: "col-12" }, { children: [_jsx("h3", Object.assign({ className: "header-section" }, { children: t('payments.dataSuscriptor.title') })), _jsxs("div", Object.assign({ className: "row px-3" }, { children: [_jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.selfEmployed)
                                                                            ? `${userProfile === null || userProfile === void 0 ? void 0 : userProfile.rlegalName} ${userProfile === null || userProfile === void 0 ? void 0 : userProfile.rlegalFirstSurname} ${userProfile === null || userProfile === void 0 ? void 0 : userProfile.rlegalLastSurname}`
                                                                            : userProfile === null || userProfile === void 0 ? void 0 : userProfile.bussinesName })), _jsx("p", Object.assign({ className: "lbl" }, { children: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.selfEmployed) ? t('payments.dataSuscriptor.name') : t('payments.dataSuscriptor.businessName') }))] })), _jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: userProfile === null || userProfile === void 0 ? void 0 : userProfile.email })), _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataSuscriptor.email') }))] })), _jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone })), _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataSuscriptor.phone') }))] })), _jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: userProfile === null || userProfile === void 0 ? void 0 : userProfile.nif })), _jsx("p", Object.assign({ className: "lbl" }, { children: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.selfEmployed) ? t('payments.dataSuscriptor.nif') : t('payments.dataSuscriptor.cif') }))] }))] }))] })), _jsxs("div", Object.assign({ className: "col-12 grid-mt-1" }, { children: [_jsx("h3", Object.assign({ className: "header-section" }, { children: t('payments.dataBilling.title') })), _jsxs("div", Object.assign({ className: "row px-3" }, { children: [_jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: responseContent === null || responseContent === void 0 ? void 0 : responseContent.numOrder })), _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataBilling.numberBilling') }))] })), _jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: formatDateToSpanishLong(responseContent === null || responseContent === void 0 ? void 0 : responseContent.paidDate) })), _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataBilling.date') }))] })), _jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsx("p", Object.assign({ className: "value" }, { children: t('payments.dataBilling.cardPayment') })), _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataPayment.typePayment') }))] })), _jsxs("div", Object.assign({ className: "col-12 col-lg-6 col-print-6 grid-mb-1" }, { children: [_jsxs("p", Object.assign({ className: "value" }, { children: [t('payments.dataPayment.anualSuscription'), _jsx(Tooltip, Object.assign({ title: t('payments.dataPayment.tooltipSuscription'), placement: "top" }, { children: _jsx(InfoOutlinedIcon, { className: "c-pointer ms-2 info-icon", fontSize: "small" }) }))] })), _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataPayment.modePayment') }))] }))] }))] })), _jsx("div", Object.assign({ className: "row data-resumen-invoice-print" }, { children: _jsxs("div", Object.assign({ className: "col-12" }, { children: [_jsxs("div", Object.assign({ className: "row breakdown-content" }, { children: [_jsx("div", Object.assign({ className: "col-6" }, { children: _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataBilling.signo-subscription') })) })), _jsx("div", Object.assign({ className: "col-6" }, { children: _jsx("p", Object.assign({ className: "lbl text-end" }, { children: formatDecimals(responseContent === null || responseContent === void 0 ? void 0 : responseContent.collectiveAmount) })) })), (responseContent === null || responseContent === void 0 ? void 0 : responseContent.discountValue) &&
                                                                    _jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "col-6 mt-2" }, { children: _jsxs("p", Object.assign({ className: "lbl" }, { children: [t('payments.discounts.discount'), " ", formatDecimals(responseContent === null || responseContent === void 0 ? void 0 : responseContent.discountValue), "%"] })) })), _jsx("div", Object.assign({ className: "col-6 mt-2" }, { children: _jsxs("p", Object.assign({ className: "lbl text-end" }, { children: ["-", formatDecimals(responseContent === null || responseContent === void 0 ? void 0 : responseContent.promotionAmount)] })) }))] })] })), _jsxs("div", Object.assign({ className: "row subtotal-tax-content" }, { children: [_jsx("div", Object.assign({ className: "col-6" }, { children: _jsx("p", Object.assign({ className: "lbl" }, { children: t('payments.dataBilling.subtotal') })) })), _jsx("div", Object.assign({ className: "col-6" }, { children: _jsx("p", Object.assign({ className: "lbl text-end" }, { children: formatDecimals(responseContent === null || responseContent === void 0 ? void 0 : responseContent.totalNet) })) }))] })), _jsxs("div", Object.assign({ className: "row subtotal-tax-content" }, { children: [_jsx("div", Object.assign({ className: "col-6" }, { children: _jsxs("p", Object.assign({ className: "lbl" }, { children: [t('payments.dataBilling.tax'), " ", responseContent === null || responseContent === void 0 ? void 0 : responseContent.tax, "%"] })) })), _jsx("div", Object.assign({ className: "col-6" }, { children: _jsxs("p", Object.assign({ className: "lbl text-end" }, { children: ["+", formatDecimals(responseContent === null || responseContent === void 0 ? void 0 : responseContent.totalTax)] })) }))] })), _jsxs("div", Object.assign({ className: "row total-content" }, { children: [_jsx("div", Object.assign({ className: "col-6" }, { children: _jsx("p", Object.assign({ className: "total-text" }, { children: t('payments.dataBilling.total') })) })), _jsx("div", Object.assign({ className: "col-6 text-end" }, { children: _jsxs("p", Object.assign({ className: "total-text" }, { children: [formatDecimals(responseContent === null || responseContent === void 0 ? void 0 : responseContent.totalGross), "\u20AC"] })) }))] })), _jsxs("div", Object.assign({ className: "row actions-payment" }, { children: [_jsxs("div", Object.assign({ className: "col-12 cta-pay-content" }, { children: [_jsx(Button, Object.assign({ type: "button", onClick: printBill, startIcon: _jsx(PrintOutlinedIcon, {}) }, { children: t('payments.feedback.btnPrint') })), _jsx(Button, Object.assign({ type: "button", onClick: downloadBill, disabled: isDownloading, startIcon: isDownloading ? _jsx(RotateRightIcon, {}) : _jsx(FileDownloadOutlinedIcon, {}) }, { children: t('payments.feedback.btnDownload') }))] })), _jsx("div", Object.assign({ className: "col-12 cta-pay-content" }, { children: _jsx(Button, Object.assign({ type: "button", onClick: () => navigate('/'), variant: "contained", className: "btn-pay" }, { children: t('common.btn.goToInit') })) }))] }))] })) }))] }))] })) })) })), _jsx("div", Object.assign({ className: "container-xl" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-md-11 mx-auto" }, { children: _jsx(Footer, {}) })) })) }))] })))] }));
};
export default PaymentsFeedbackOk;
